import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useEffect, useState, useContext } from 'react';
import PostBlockGrid from '../PostBlock/PostBlockGrid';
import { initializeApollo } from '../../utils/apolloClient';
import { SINGLE_PROFILE } from './SingleProfileQuery';
import { useScrollRestoration } from '../../utils/useScrollRestoration';
import AppContext from '../../context/AppContext';

export default function SingleProfilePosts({
	profileType, profilePosts, setProfilePosts, title, defaultLimit, authorSlug,
}) {
	const [showLoadMoreAnimation, setShowLoadMoreAnimation] = useState(false);
	const [currentPage, setCurrentPage] = useState(null);
	const [firstPageLoad, setFirstPageLoad] = useState(true);
	const Router = useRouter();
	const adConfig = {
		adStartPosition: 3,
		adName: 'profile-posts-ad',
		loadGoogleAds: true,
	};
	const { isUsTraffic } = useContext(AppContext);

	const handleLoadMore = () => {
		const nextPage = currentPage + 1;
		const asUrl = `${Router.query.profileSlug}?page=${nextPage}`;
		Router.query.page = nextPage;
		Router.replace(Router, asUrl, { shallow: true });
	};

	const getMorePostBlocks = async (page) => {
		const limit = page ? parseInt(page, 10) * defaultLimit : defaultLimit;

		const variables = {
			authorSlug,
			limit,
			paged: 1,
			excludeUS: isUsTraffic === true,
		};

		setShowLoadMoreAnimation(true);

		const apolloClient = initializeApollo();
		const response = await apolloClient.query({
			query: SINGLE_PROFILE,
			variables,
		});

		if (response.data?.profile) {
			setShowLoadMoreAnimation(false);
			setProfilePosts(response.data?.profile.authorRecipes);
		}
	};

	useEffect(() => {
		const pageFromUrl = parseInt(Router?.query?.page, 10) || 1;
		setCurrentPage(pageFromUrl);

		if (firstPageLoad) {
			setFirstPageLoad(false);
			return;
		}

		getMorePostBlocks(pageFromUrl);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Router]);

	// Restore last location.
	useScrollRestoration(Router);
	if (!profilePosts.found_posts > 0) return null;

	const adobeAnalyticsData = {
		name: `${authorSlug}:load-more`,
	};

	return (
		<div className="profile-recipes">
			{profileType !== 'staff' && <h2 className="profile-recipes-title">{`More From ${title}`}</h2>}
			<PostBlockGrid posts={profilePosts?.associatedRecipes} passQueryVar adConfig={adConfig} className="profile-recipes-grid" />
			{showLoadMoreAnimation && <PostBlockGrid className="loader-grid" posts={[]} isLoader={showLoadMoreAnimation} /> }
			{profilePosts?.paged !== profilePosts?.max_num_pages && (
				<div className="profile-load-more">
					<button
						className="profile-load-more-btn"
						onClick={handleLoadMore}
						type="button"
						aria-label={`Load More from ${title}`}
						data-analytics={JSON.stringify(adobeAnalyticsData, null, 2)}
					>
						Load More
					</button>
				</div>
			)}
		</div>
	);
}

SingleProfilePosts.propTypes = {
	profileType: PropTypes.string.isRequired,
	profilePosts: PropTypes.object.isRequired,
	title: PropTypes.string.isRequired,
	defaultLimit: PropTypes.number.isRequired,
	authorSlug: PropTypes.string.isRequired,
	setProfilePosts: PropTypes.func.isRequired,
};
